/**
 * /dashboard/settings/competencies — Settings → People & HR →
 * Competencies (SOP §8).
 *
 * Reuses the existing CompetenciesTab body — the competency framework
 * + matrix admin UI from the Performance hub. Lifted into Settings
 * per SOP §8.3 (catalog admin lives in Settings, not in module nav).
 *
 * Migration note (2026-06-01, Next.js → Vite Phase 3g): direct port of
 * frontend/src/app/(dashboard)/dashboard/settings/competencies/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CompetenciesTab } from "@/components/performance/competencies-tab";
import { SettingsPageHeader } from "@/components/shared/settings-page-header";
import { SettingsShell } from "@/components/shared/settings-shell";
import { SETTINGS_GROUPS } from "@/lib/settings-nav";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/competencies",
)({
  component: SettingsCompetenciesRoute,
});

function SettingsCompetenciesRoute() {
  return (
    <>
      <SettingsPageHeader />
      <SettingsShell groups={SETTINGS_GROUPS}>
        <div className="space-y-6">
          <div>
            <h2 className="text-lg font-semibold">Competencies</h2>
            <p className="text-sm text-muted-foreground">
              Define your competency framework and review the per-employee
              matrix.
            </p>
          </div>
          <CompetenciesTab />
        </div>
      </SettingsShell>
    </>
  );
}
